import {fromUtcTimeFormat} from "../../../shared/utils/dayjsUtil";
import {getItemName} from "../../../shared/utils/basic";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

export const getLuckyArcadeLogColumns = (krTextData, currentUser) => {
    return [
        {
            title: '로그 타입',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).logType,
        },
        {
            title: '트리거 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {triggerTime} = parseLogData(logString, record);
                return triggerTime ? fromUtcTimeFormat(triggerTime) : '';
            },
        },
        {
            title: '세그먼트',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).segment,
        },
        {
            title: '보상획득경로',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).rewardSource,
        },
        {
            title: '타일 번호',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).tileNumber,
        },
        {
            title: '획득 아이템',
            dataIndex: 'logString',
            render: (logString, record) => (parseLogData(logString, record).itemInfo || [])
                .map(({ItemType, ItemIndex, Count}) =>
                    `${getItemName(krTextData[currentUser.target], ItemIndex, ItemType)}(${ItemIndex}) ${Count}개`)
                .join(', '),
            width: '30%',
        },
    ];
};
